// ─────────────────────────────────────────────────────────────
//  STEP 1: Paste your Firebase config here
//  Get it from: Firebase Console → Project Settings → Your Apps
// ─────────────────────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDF3n77_wxMdnzF7pjsdOKRf6CUQVixVm0",
  authDomain: "budget-tracker-60e6d.firebaseapp.com",
  projectId: "budget-tracker-60e6d",
  storageBucket: "budget-tracker-60e6d.firebasestorage.app",
  messagingSenderId: "931988525475",
  appId: "1:931988525475:web:45c40ef0502d7aaac94a16",
  measurementId: "G-1DDHF8DBF4"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
